import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const GET_ITEM_QUERY = print(gql`
  query Log($id: String!) {
    Log(id: $id) {
      id
      origin
      content
      category
      userId
      createdAt
    }
  }
`);

export const responseGetItemKey = "Log";

export interface SchemaDataGetItem {
  id: string;
  origin: string;
  content: string;
  category: string;
  userId?: string;
  createdAt: Date;
}

export interface GetItemGql {
  [responseGetItemKey]: SchemaDataGetItem;
}
